import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [ButtonModule],
    templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private redirectUrl: string = '';
    private backendUrl: string = '';
    ngOnInit(): void {
        this.redirectUrl = this.route.snapshot.queryParamMap.get('redirectUrl') || '/';
        this.backendUrl = this.route.snapshot.data['backendUrl'];
    }

    redirectToLogin() {
        this.logOut(decodeURIComponent(this.redirectUrl));
    }

    logOut(path?: string): void {
        window.location.href = `${this.backendUrl}/auth/logout?redirectUrl=${path}`;
    }
}
